import { getProcurementPurchaseRequests } from 'api'
import { useFilter } from 'hooks/useFilter'
import { colors, H2 } from 'styling/GlobalStyles'
import { toCsv } from 'utils/helpers'
import { useQuery } from '@tanstack/react-query'

type FilterValues = {
  departmentId: string | number | null
  clientStatus: string | null
}

export const PurchaseRequestHeader = () => {
  const { values } = useFilter<FilterValues>({
    departmentId: null,
    clientStatus: null,
  })
  const { data } = useQuery({
    queryKey: ['procurement-purchase-requests', values],
    queryFn: () =>
      getProcurementPurchaseRequests({
        departmentIds: values.departmentId ? toCsv([values.departmentId]) : undefined,
        clientStatuses: values.clientStatus ? toCsv([values.clientStatus]) : undefined,
        page: values.page,
        limit: values.limit,
      }),
  })
  return (
    <H2 noUpperCase>
      {data?.totalCount} total requests •{' '}
      <span style={{ color: colors.orange }}>{data?.data.length} Shown</span>
    </H2>
  )
}
